import React, { Component } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/styles";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import {
  AppWrapper,
  AppIcons,
  Footer,
  MenuUser,
  Sidebar,
  ThemeCreate,
  Topbar
} from "../components/sharedComponents";
import ComposeContent from "./../containers/ComposeContent";
import ContactUsContent from "./../containers/ContactUsContent";
import ViewContent from "./viewContent/ViewContent";
import ViewMessageContent from "./../containers/ViewMessageContent";
import {
  postAPIEmployee,
  postAPIMailbox,
  postAPIMailboxes,
  postAPIMessages,
  postAPIMessagesReceived,
  postUserDraftUpdated,
  postUserPermissionsDetailed,
  postUserSettingsGlobal,
  postUserSettingsGlobalLastUsedSettings,
  postUserSettingsLocal,
  postUserSites
} from "./../redux/actions";
import Drafts from "./Drafts";
import PopupAlert from "./PopupAlert";
import {
  b2cUserType,
  b2cLogout,
  b2cGetAccount
} from "../components/sharedComponents/auth-wrapper";
import { getOneMonthAgo } from "../components/helperFunctions/helperFunctions";
import ViewSelector from "./ViewSelector";
import ThereforePopup from "./ThereforePopup";
import ApiMessages from "../services/ApiMessages";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: getOneMonthAgo(),
      toDate: new Date().toLocaleDateString(),
      Permissions: null,
      UserSettings: false,
      popupAlertOpen: false,
      popupAlertmessage: "",
      popupAlertIsSuccessMessage: false,
      initialLoad: true,
      isMessagesLoading: false,
      isThereforeOpen: false,
      favoriteEmail: "",
      thereforeData: {
        Firm: "",
        Office: "",
        Account: "",
        Short_Name: "",
        Sales_Code: "",
        CNA_1: "",
        Tax_ID: "",
        CFTC_Office: "",
        CFTC_Account: "",
        Date_Opened: "",
        Date_Closed: "",
        Doc_Type: "",
        Doc_ID: "",
        Date_Scanned: "",
        Original_account_number: "",
        Original_Firm: "",
        Original_Office: "",
        Original_S_Code: ""
      },
      thereforeAttachments: []
    };
    this.apiClass = props.ApiClass;
    this.apiMessages = new ApiMessages(this.apiClass);
    this.onStarIconClick = this.onStarIconClick.bind(this);
    this.onDateChanged = this.onDateChanged.bind(this);
  }

  componentDidMount() {
    this.SetMailboxList();
    this.setupUser();
    this.SetIsEmployee();
    this.SetSecureMessages();
    this.intervalId = setInterval(() => {
      if (!window.document.hidden) {
        //if browser tab is active
        this.SetSecureMessages();
      }
    }, 1000 * 60); // 1 minute
  }

  //|| prevProps.getAPIMailbox !== this.props.getAPIMailbox
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.mailbox !== this.props.match.params.mailbox) {
      this.SetSecureMessages();
      this.props.postAPIMailbox(this.props.match.params.mailbox);
      this.props.postAPIMessagesReceived(false);
      this.props.postAPIMessages([]);
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  onStarIconClick = (e, email) => {
    e.stopPropagation();
    localStorage.setItem("favoriteEmail", email);
    this.setState({ favoriteEmail: email });
  };

  /**
   *
   * @param {Array} value - The new date value.
   * [0]- fromDate
   * [1]-toDate
   */
  onDateChanged = (value) => {
    this.setState({
      fromDate: new Date(value[0]).toLocaleDateString(),
      toDate: new Date(value[1]).toLocaleDateString()
    });
  };

  initialMailboxLoad = () => {
    let localFavEmail = localStorage.getItem("favoriteEmail");
    //if locally saved email exist in the permitted email box
    if (localFavEmail && this.props.getAPIMailboxes.indexOf(localFavEmail)) {
      return this.props.history.push("/" + localFavEmail + "/inbox");
    }
    if (
      !this.props.match.params.mailbox ||
      (this.props.getAPIMailboxes.length > 0 &&
        this.props.getAPIMailboxes.indexOf(this.props.match.params.mailbox) ===
          -1)
    ) {
      this.props.history.push("/" + b2cGetAccount().username + "/inbox");
    }
  };

  defaultMailboxToGroup(mailboxes) {
    let localFavEmail = localStorage.getItem("favoriteEmail");
    //if locally saved email exist in the permitted email box
    if (localFavEmail && this.props.getAPIMailboxes.indexOf(localFavEmail)) {
      this.props.postAPIMailbox(localFavEmail);
      this.props.history.push("/" + localFavEmail + "/inbox");
      return;
    }

    if (mailboxes.length === 1) {
      this.props.history.push("/" + mailboxes[0] + "/inbox");
      this.props.postAPIMailbox(mailboxes[0]);
    } else {
      const groupEmails = mailboxes.filter(
        (mail) => mail !== b2cGetAccount().username
      );
      this.props.history.push("/" + groupEmails[0] + "/inbox");
      this.props.postAPIMailbox(groupEmails[0]);
    }
  }

  setErrorMessage = (message) => {
    this.setState({
      circularProgressOpen: false,
      popupAlertmessage: message,
      popupAlertOpen: true
    });
  };

  SetSecureMessages = async () => {
    this.setState({ isMessagesLoading: true });
    if (this.props.match.params.mailbox) {
      return await this.apiMessages
        .getMessages(
          this.props.match.params.mailbox,
          this.state.fromDate,
          this.state.toDate
        )
        // return await this.apiClass
        //   .GetSecureMessages(this.props.match.params.mailbox)
        .then((res) => {
          this.props.postAPIMessages(res);
          this.props.postAPIMessagesReceived(true);
          this.setState({ isMessagesLoading: false });
        })
        .catch((err) => {
          this.setState({ isMessagesLoading: false });
        });
    }
  };

  openThereforePopup = () => {
    this.setState({ isThereforeOpen: true });
  };

  handleThereforeClose = () => {
    this.setState({ isThereforeOpen: false });
  };

  setThereforeData = (curForm) => {
    this.setState({ thereforeData: curForm });
  };

  SetMailboxList = async () => {
    //if favorite exist in local storage
    this.setState({
      favoriteEmail: localStorage.getItem("favoriteEmail") || ""
    });

    await this.apiClass
      .GetMailboxList()
      .then((res) => {
        this.defaultMailboxToGroup(res);
        this.props.postAPIMailboxes(res);
      })
      .catch((err) => {
        this.setState({ isMessagesLoading: false });
      });
  };

  SetIsEmployee = async () => {
    return await this.apiClass.GetIsEmployee().then((res) => {
      this.props.postAPIEmployee(res);
    });
  };

  // Check if user is logged in
  setupUser() {
    this.props.postUserSites(this.props.UserPermissions);
    this.props.postUserPermissionsDetailed(this.props.UserPermissionDetailed);

    // Get User's Settings
    if (this.props.UserSettings.global) {
      var UserSettingsGlobalData = this.props.UserSettings.global.customData;
      if (
        !UserSettingsGlobalData ||
        UserSettingsGlobalData.LastUsedSettings === undefined
      ) {
        const LastUsedSettings = {
          SidebarSearch: {
            Office: "",
            Account: "",
            SalesCode: "",
            AccountName: ""
          },
          SelectedAccount: "",
          Currency: ""
        };
        if (!UserSettingsGlobalData) {
          UserSettingsGlobalData = {
            LastUsedSettings: LastUsedSettings
          };
        } else {
          UserSettingsGlobalData.LastUsedSettings = LastUsedSettings;
        }
      }
      this.props.postUserSettingsGlobalLastUsedSettings(
        UserSettingsGlobalData.LastUsedSettings
      );
      this.props.postUserSettingsGlobal(UserSettingsGlobalData);
    }
    this.props.UserSettings.local &&
      this.props.postUserSettingsLocal(
        this.props.UserSettings.local.customData
      );
  }

  marginWidth = () => {
    if (
      this.props.getUserSettingsGlobalSidebarAvailable &
      this.props.getUserSettingsGlobalSidebarVisible
    )
      return 320;
    else if (this.props.getUserSettingsGlobalSidebarAvailable) return 50;
    else return 0;
  };
  renderContent() {
    switch (this.props.action) {
      case "Compose":
        return (
          <ComposeContent
            apiClass={this.apiClass}
            history={this.props.history}
            mailbox={this.props.match.params.mailbox}
            updateMessages={() => this.SetSecureMessages()}
          />
        );
      case "Drafts":
        return (
          <Drafts
            apiClass={this.apiClass}
            drafts={this.props.getUserSettingsLocalDrafts}
            history={this.props.history}
            mailbox={this.props.match.params.mailbox}
          />
        );
      case "Contact Us":
        return (
          <ContactUsContent
            apiClass={this.apiClass}
            history={this.props.history}
            mailbox={this.props.match.params.mailbox}
            updateMessages={() => this.SetSecureMessages()}
          />
        );
      default:
        if (this.props.match.params.messageId == null) {
          if (this.state.isThereforeOpen) {
            return (
              <div>
                <ViewContent
                  fromDate={this.state.fromDate}
                  toDate={this.state.toDate}
                  onDateChanged={this.onDateChanged}
                  apiClass={this.apiClass}
                  mailbox={this.props.match.params.mailbox}
                  path={this.props.path}
                  history={this.props.history}
                  action={this.props.action}
                  permissions={this.props.UserPermissionDetailed}
                  attachments={this.state.thereforeAttachments}
                  updateMessages={() => this.SetSecureMessages()}
                  openThereforePopup={() => this.openThereforePopup()}
                  ownerEmail={b2cGetAccount().username}
                  isMessagesLoading={this.state.isMessagesLoading}
                />
                <ThereforePopup
                  apiClass={this.apiClass}
                  rowData={this.state.thereforeData}
                  attachments={this.state.thereforeAttachments}
                  handleModalClose={this.handleThereforeClose}
                  messageContents={this.props.getAPIMessage}
                  mailbox={this.props.match.params.mailbox}
                  setRow={this.setThereforeData}
                />
              </div>
            );
          } else {
            return (
              <ViewContent
                fromDate={this.state.fromDate}
                toDate={this.state.toDate}
                onDateChanged={this.onDateChanged}
                apiClass={this.apiClass}
                mailbox={this.props.match.params.mailbox}
                path={this.props.path}
                history={this.props.history}
                action={this.props.action}
                permissions={this.props.UserPermissionDetailed}
                attachments={this.state.thereforeAttachments}
                updateMessages={() => this.SetSecureMessages()}
                openThereforePopup={() => this.openThereforePopup()}
                ownerEmail={b2cGetAccount().username}
                isMessagesLoading={this.state.isMessagesLoading}
              />
            );
          }
        } else {
          return (
            <ViewMessageContent
              apiClass={this.apiClass}
              mailbox={this.props.match.params.mailbox}
              path={this.props.path}
              history={this.props.history}
              action={this.props.action}
              messageId={this.props.match.params.messageId}
            />
          );
        }
    }
  }
  render() {
    let icons = this.props.Icons;
    let userType = b2cUserType();
    let userName = b2cGetAccount().name;
    let userEmail = b2cGetAccount().username;

    return (
      <div style={{ minimumWidth: "900px" }}>
        <ThemeProvider theme={ThemeCreate("light")}>
          <PopupAlert
            errorOpen={this.state.popupAlertOpen}
            handleErrorClose={() => {
              this.setState({ popupAlertOpen: false });
            }}
            errorMessage={this.state.popupAlertmessage}
            isSuccessMessage={this.state.popupAlertIsSuccessMessage}
          />
          <CssBaseline />
          <Topbar
            userType={this.props.userType}
            sites={icons}
            MenuUserSettings={
              <MenuUser
                UserSettings={this.props.getUserSettings}
                apiClass={this.apiClass}
                UserName={userName}
                UserEmail={userEmail}
                b2cLogout={b2cLogout}
                customSettings={[["Global", "Sidebar", "Available"]]}
              />
            }
            AppIcons={() => {
              return (
                <AppIcons
                  iconSizes={[12, 6, 6, 4]} // xs, sm, md, lg
                  sites={icons}
                  UnreadMessageCount={this.props.UnreadMessageCount}
                  pendingUsersCount={this.props.PendingUsersCount}
                  fontSize="0.9rem"
                  iconImageSize="75px"
                />
              );
            }}
          />
          <Sidebar
            apiClass={this.apiClass}
            componentone={() => {
              return (
                <ViewSelector
                  action={this.props.action}
                  history={this.props.history}
                  favoriteEmail={this.state.favoriteEmail}
                  onStarIconClick={this.onStarIconClick.bind(this)}
                />
              );
            }}
          />
          <div
            style={{
              marginLeft: this.marginWidth(),
              marginTop: "100px",
              marginRight: "15px"
            }}
          >
            {this.renderContent()}
          </div>
          <Footer userType={userType} />
        </ThemeProvider>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    getAPIMessages: state.API.Messages,
    getAPIMessage: state.API.Message,
    getUserSettingsLocalSidebar: state.User.Settings.Local.Sidebar,
    getUserSettingsGlobalLastUsedSettings:
      state.User.Settings.Global.LastUsedSettings,
    getAPIMailbox: state.API.Mailbox,
    getAPIMailboxes: state.API.Mailboxes,
    getUserSettingsGlobalSidebarVisible:
      state.User.Settings.Global.Sidebar.Visible,
    getUserSettingsGlobalSidebarAvailable:
      state.User.Settings.Global.Sidebar.Available,
    getUserSites: state.User.Sites,
    getUserSettings: state.User.Settings,
    getUserSettingsGlobal: state.User.Settings.Global,
    getUserSettingsLocal: state.User.Settings.Local,
    getUserSettingsLocalDrafts: state.User.Settings.Local.Drafts,
    getUserDraftUpdated: state.User.DraftUpdated
  };
}

const mapDispatchToProps = {
  postAPIMessages,
  postUserSettingsGlobalLastUsedSettings,
  postUserSites,
  postUserPermissionsDetailed,
  postUserSettingsLocal,
  postUserSettingsGlobal,
  postAPIEmployee,
  postAPIMessagesReceived,
  postAPIMailboxes,
  postAPIMailbox,
  postUserDraftUpdated
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(AppWrapper(App)));
